import { useState, useEffect } from "react";

const navLinks = [
  { href: "#about", label: "About Us" },
  { href: "#menu", label: "View Menu" },
  { href: "#event", label: "Event Price" },
  { href: "#promotion", label: "Promotion" },
  { href: "#experience", label: "Experience" },
  { href: "#contact", label: "Contact Us" },
  { href: "#find-us", label: "Find Us" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-sm py-2"
          : "bg-transparent py-4"
      }`}
    >
      <div className="mx-auto px-4 md:px-6 flex items-center justify-between">
        <a href="#hero" className="flex items-center gap-2 group">
          <img
            src="https://public.readdy.ai/ai/img_res/db2fbb2a-da28-48d0-b12b-fa6e808261bd.png"
            alt="BB COFFEE BeanhoodBrew Logo"
            className="h-10 md:h-12 w-auto object-contain transition-all duration-300 group-hover:scale-105"
          />
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`relative px-3 py-2 text-sm font-medium transition-colors duration-300 group whitespace-nowrap ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600"
                  : "text-background-200 hover:text-primary-300"
              }`}
            >
              {link.label}
              <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-primary-500 rounded-full transition-all duration-300 group-hover:w-3/4" />
            </a>
          ))}
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center transition-colors cursor-pointer ${
            scrolled ? "text-foreground-700 hover:text-primary-600" : "text-background-200 hover:text-primary-300"
          }`}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </div>

      <div
        className={`lg:hidden overflow-hidden transition-all duration-400 ${
          mobileOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="bg-background-50/95 backdrop-blur-md px-6 py-4 flex flex-col gap-1 border-t border-background-200/50">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="py-3 px-4 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50/50 rounded-lg transition-all duration-300"
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
}